import React from 'react'
import Preloader from '../../Global/Preloader';
import Headertwo from '../../Global/Headertwo';
import Servicebred from '../../Global/Servicebred';
import Servicesthree from '../../Services/Mainservices1/Servicesthree';
import Testimonialone from '../../Home/Mainhomeone/Testimonialone';
import Pricingplan from '../../Services/Mainservices1/Pricingplanone';
import Ctaone from '../../Global/Ctaone';
import Footertwo from '../../Global/Footertwo';
import BackToTop from '../../Global/BackToTop';
import Experience from '../../Global/Experience'
import Processtwo from '../../Home/Mainhometwo/Processtwo';
import Will from '../../Global/Will'
import Will2 from '../../Global/Will2'
import Will3 from '../../Global/Will3'
import Teamone from '../../Home/Mainhomeone/Teamone';
import Footer from '../../Global/Footer';
import Inquiryone from '../../Home/Mainhometwo/Inquiryone';

const Main = () => {
    return (
        <>
            {/* <Preloader /> */}
            <Headertwo />
            <Servicebred  />
            <Experience/>
            <Processtwo/>
            <Will/>
            <Teamone/>
            <Will2/>
            <Will3/>
            <Inquiryone/>
            {/* <Servicesthree />
            <Testimonialone />
            <Pricingplan />
            <Ctaone /> */}
            <Footer/>
            <BackToTop/>
        </>
    )
}
export default Main;